"use strict";

var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.EditableTableCell = exports.EditableTableFormRow = exports.EditableTableRow = void 0;
const react_1 = __importDefault(require("react"));
const form_1 = __importDefault(require("antd/lib/form"));
const Form_1 = require("../../../Form");
const EditableContext = react_1.default.createContext(null);
const EditableTableRow = _a => {
  var form = _a.form,
    props = __rest(_a, ["form"]);
  return react_1.default.createElement(EditableContext.Provider, {
    value: form
  }, react_1.default.createElement("tr", Object.assign({}, props)));
};
exports.EditableTableRow = EditableTableRow;
exports.EditableTableFormRow = form_1.default.create()(exports.EditableTableRow);
class EditableTableCell extends react_1.default.Component {
  render() {
    const _a = this.props,
      editable = _a.editable,
      children = _a.children,
      name = _a.name,
      record = _a.record,
      ref = _a.ref,
      decoratorOptions = _a.decoratorOptions,
      restProps = __rest(_a, ["editable", "children", "name", "record", "ref", "decoratorOptions"]);
    return react_1.default.createElement("td", Object.assign({}, restProps, {
      ref: ref
    }), editable ? react_1.default.createElement(EditableContext.Consumer, null, form => react_1.default.createElement(form_1.default.Item, null, form.getFieldDecorator(name, Object.assign({
      initialValue: record[name]
    }, decoratorOptions))(react_1.default.createElement(Form_1.Input, Object.assign({}, restProps))))) : children);
  }
}
exports.EditableTableCell = EditableTableCell;
exports.default = EditableTableCell;